import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import { hasAtLeastOneRequiredAction } from "utils/access";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AccountContext } from "views/AccountWrapper";
import { Space } from "types/generated";
import { MODULE_CREATE_ACCESS_TYPES } from "shared/Module/access/useCanCreateModule";

const useModuleAvailableSpaces = (): Space[] => {
  const { spaces } = useTypedContext(SpacesContext);
  const { viewer } = useTypedContext(AccountContext);

  const availableSpaces = useMemo(() => {
    return spaces?.filter((space) => {
      return hasAtLeastOneRequiredAction(MODULE_CREATE_ACCESS_TYPES, viewer, space.id);
    });
  }, [spaces, viewer]);

  return availableSpaces || [];
};

export default useModuleAvailableSpaces;
